import React from "react";
import "../App.css";

export default function StaffTraining() {
  return (
    <div className="page-in-development" id="staff-training">
      <h4>Данная страница находится в разработке</h4>
    </div>
  );
}
